module.exports = __webpack_public_path__ + "img/minus_btn.5287bb38.png";